















import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
    components: {
    },
})
export default class MessageVue extends Vue {

    @Prop({default:''})
    private text!: string;

}

